export const MIN_CONVERSION_RATE_VALUE = 0.01;
export const MAX_CONVERSION_RATE_VALUE = 150000;
export const MIN_FEE_VALUE = 0;
export const MAX_FEE_VALUE = 100;
export const MIN_DEPOSIT_VALUE = 0;
export const MAX_DEPOSIT_VALUE = 2147483647;
export const MIN_NON_WFP_LOTS_VALUE = 1;
export const MIN_UNHCR_SERVICES_VALUE = 0;
